import { useUserStore } from '~/stores/user';
import { useDjustAuth } from '~/composables/useDjustAuth';

export default defineNuxtPlugin(async (nuxtApp) => {
  if (process.server) return; // Ensure it only runs on the client

  const isAuthenticated = computed(() => useCookie('isAuthenticated').value);
  const customerAccountId = useCookie('customer-account-id').value;
  const storeId = useCookie('store-id').value as string;
  const storeViewId = useCookie('store-view-id').value as string;
  const currency = useCookie('currency').value as string;
  const { getAuthenticatedUser } = useDjustAuth();
  const { switchCustomerAccount } = useAccount();

  try {
    // Fetch and update the user store
    const authenticatedUser = isAuthenticated.value ? await getAuthenticatedUser(true) : null;
    const params = {
      ...(customerAccountId && { customerAccountId }),
      ...(storeId && storeViewId && { storeId, storeViewId }),
      ...(currency && { currency }),
    };
    if (Object.keys(params).length && isAuthenticated.value) {
      switchCustomerAccount(params);
    }
    if (!authenticatedUser) {
      console.warn('⚠️ No authenticated user found, logging out.');
    }
  } catch (error) {
    console.error('🚨 Error initializing user store:', error);
    //userStore.logout();
  }
});
